module.exports = __webpack_public_path__ + "img/group.361d5d0e.svg";